import { createUseStyles } from 'react-jss';
import { BackgroundColors } from '@picsart/design-system/foundation/backgroundColors';
import { TextColors } from '@picsart/design-system/foundation/textColors';
import { Spacings } from '@picsart/design-system/foundation/spacings';
import { CornerRadius } from '@picsart/design-system/foundation/cornerRadius';
import {
  FontSizes,
  LineHeights,
} from '@picsart/design-system/foundation/typography';
import { FontWeights } from '@picsart/design-system/foundation/fonts';
import { StackingContext } from '@picsart/design-system/foundation/stackingContext';

const GILROY = '"Picsart-Fonts", sans-serif';

const useStyles = createUseStyles(
  {
    wrapper: {
      position: 'relative',
    },
    avatarBtn: {
      background: 'none',
      border: 'none',
      padding: 0,
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      borderRadius: CornerRadius.circle,
      '& *': {
        cursor: 'pointer',
      },
    },
    sheetContent: {
      padding: `${Spacings.s4} 0`,
      overflowY: 'auto',
    },
    dropdown: {
      position: 'absolute',
      top: 'calc(100% + 6px)',
      right: 0,
      backgroundColor: BackgroundColors.tint1,
      border: `1px solid ${BackgroundColors.border}`,
      borderRadius: CornerRadius.r12,
      zIndex: StackingContext.PopoverLayer,
      width: 300,
      overflowY: 'auto',
      boxShadow: '0 4px 16px rgba(0,0,0,0.12)',
      padding: `${Spacings.s8} 0`,
    },
    userCard: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      padding: `${Spacings.s4} ${Spacings.s16} ${Spacings.s16}`,
    },
    userInfo: {
      display: 'flex',
      flexDirection: 'column',
      gap: 2,
      minWidth: 0,
      flex: 1,
    },
    userName: {
      fontFamily: GILROY,
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.semibold,
      lineHeight: LineHeights.l24,
      color: TextColors.base,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    userHandle: {
      fontFamily: GILROY,
      fontSize: FontSizes.s14,
      lineHeight: LineHeights.l20,
      color: TextColors.tint2,
      display: 'block',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
    },
    menuSection: {
      display: 'flex',
      flexDirection: 'column',
      gap: Spacings.s4,
      padding: `0 ${Spacings.s8}`,
    },
    menuItem: {
      display: 'flex',
      alignItems: 'center',
      gap: Spacings.s12,
      width: '100%',
      padding: `${Spacings.s12} ${Spacings.s12}`,
      border: 'none',
      borderRadius: CornerRadius.r12,
      backgroundColor: BackgroundColors.tint1,
      color: TextColors.base,
      fontFamily: GILROY,
      fontSize: FontSizes.s16,
      fontWeight: FontWeights.medium,
      lineHeight: LineHeights.l24,
      cursor: 'pointer',
      transition: 'background-color 0.15s ease',
      WebkitTapHighlightColor: 'transparent',
      '&:hover': {
        backgroundColor: BackgroundColors.tint2,
      },
      '&:active': {
        backgroundColor: BackgroundColors.tint3,
      },
    },
    menuItemIcon: {
      width: 20,
      height: 20,
      flexShrink: 0,
      color: TextColors.tint1,
    },
    menuItemContent: {
      flex: 1,
      textAlign: 'left',
    },
    menuItemEnd: {
      display: 'flex',
      alignItems: 'center',
      color: TextColors.tint2,
    },
    creditsValue: {
      fontFamily: GILROY,
      fontSize: FontSizes.s14,
      color: TextColors.tint2,
      marginRight: Spacings.s4,
    },
  },
  { name: 'UserMenuButton' }
);

export default useStyles;
